import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueMissingDisplayModel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m1.46.045-.01.01L20.542 19.15l-1.404 1.404-2.671-2.67h-.174v2.646h-2v-2.647H5.706v2.647h-2v-2.647H1V11.53h3.235V5.65L0 1.415 1.414 0l.045.045ZM5.18 1l2 2h6.585v6.585L19 14.821v-3.292h-3.235V1H5.179Zm1.055 10.53V7.65l3.88 3.88h-3.88ZM3 13.53h9.115l2.353 2.352H3V13.53Z",
		fill: "#111"
	})
});
export default SvgIssueMissingDisplayModel;
